import { useCallback, useEffect, useState } from 'react'

const useGlobalSearchShortcut = () => {
  const [show, setShow] = useState(false)

  const onOpen = useCallback(() => setShow(true), [])
  const onClose = useCallback(() => setShow(false), [])

  useEffect(() => {
    const handleKeyDown = event => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault()
        setShow(prev => !prev)
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])

  return { show, onOpen, onClose }
}

export default useGlobalSearchShortcut
